// @flow strict

import * as React from 'react';
import TextAndMedia, {
  type VideoPropsTypes,
  type TextAndMediaPropTypes,
} from '../../internal/TextAndMedia';
import WistiaVideo from '../../internal/WistiaVideo';

type PropTypes = {|
  ...TextAndMediaPropTypes,
  ...VideoPropsTypes,
|};

const TextAndVideo = (props: PropTypes) => {
  return (
    <TextAndMedia
      background={props.background}
      position={props.position}
      intro={props.intro}
      title={props.title}
      media={<WistiaVideo wistiaId={props.embeddedId} aspectRatio="16:9" />}
      content={props.content}
    />
  );
};

TextAndVideo.defaultProps = {
  position: 'Left',
  background: 'Low',
};

export default TextAndVideo;
